import React from "react";

const SocialIcon = ({ href, Icon }) => {
  return (
    <a
      href={href || "#"}
      target="_blank"
      rel="noreferrer"
      className="flex size-10 items-center justify-center transition"
    >
      <Icon className="text-dark text-sm" />
    </a>
  );
};

export default SocialIcon;